import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { TakeawayServices } from '../../../takeaway/services';
import { OdsServices } from '../../../ods/services';

/**
 * Generated class for the OdsListViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-integration-uberdirect',
    templateUrl: 'configuration-integration-uberdirect.html',
})
export class ConfigurationIntegrationUberDirectPage {

    customer_id = '';
    client_id = '';
    customer_secret = '';

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public translate: TranslateService,
        public globals: Globals,
        public toastCtrl: ToastController,
        public odsServices: OdsServices,
        public takeawayServices: TakeawayServices) {
        if (this.globals.restaurant.uber_direct_customer_id) {
            this.customer_id = this.globals.restaurant.uber_direct_customer_id;
        }
        if (this.globals.restaurant.uber_direct_client_id) {
            this.client_id = this.globals.restaurant.uber_direct_client_id;
        }
        if (this.globals.restaurant.uber_direct_client_secret) {
            this.customer_secret = this.globals.restaurant.uber_direct_client_secret;
        }
    }

    save(goBack = true) {
        this.takeawayServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            uber_direct_customer_id: this.customer_id,
            uber_direct_client_id: this.client_id,
            uber_direct_client_secret: this.customer_secret
        }).then(() => {
            this.globals.restaurant.uber_direct_customer_id = this.customer_id;
            this.globals.restaurant.uber_direct_client_id = this.client_id;
            this.globals.restaurant.uber_direct_client_secret = this.customer_secret;
        });
        if (goBack) {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-guardado-correctamente'),
                duration: 3000,
                position: 'top'
            });
            toast.present();
            this.navCtrl.pop();
        }
    }

    changeActive(active) {
        if (this.customer_id && this.client_id && this.customer_secret) {
            this.takeawayServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                uber_direct_active: active
            }).then(() => {
                this.globals.restaurant.uber_direct_active = active;
                this.save(false);
            });
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-completa-todos-campos'),
                duration: 3000,
                position: 'top'
            });
            toast.present();
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-integrations/configuration-integration-uberdirect/configuration-integration-uberdirect.ts